import { getConfig } from '@/utils/config/config';
import { InterceptBuilder } from '../interceptor/builder';
import { credentialsInterceptor } from '../interceptor/interceptors/request/credentials-interceptor';
import { internalNetworkInterceptor } from '../interceptor/interceptors/request/internal-network-interceptor';
import { mockWorkerInterceptor } from '../interceptor/interceptors/request/mock-worker-interceptor';
import { pxRequestInterceptor } from '../interceptor/interceptors/request/px-request-interceptor';
import { pxResponseInterceptor } from '../interceptor/interceptors/response/px-response-interceptor';

const config = getConfig();

const interceptBuilder = new InterceptBuilder(fetch);

// Request Interceptor

if (config.unifiedModules.pxEnabled) {
    interceptBuilder.intercept(pxRequestInterceptor, { index: 0 }); // Enforce first interceptor
}

interceptBuilder.intercept(credentialsInterceptor);

// Mock worker interceptor: only register for MockServer-backed builds.
// This avoids unnecessary async getCookieValue() calls on every production request.
// CONFIG_ENV is set at build time via NODE_CONFIG_ENV in next.config.mjs.
const MOCK_SERVER_CONFIG_ENVS: readonly string[] = ['devstack-mock', 'local-mockserver', 'mock-harness'];

if (MOCK_SERVER_CONFIG_ENVS.includes(process.env.CONFIG_ENV)) {
    interceptBuilder.intercept(mockWorkerInterceptor);
}

interceptBuilder.intercept(internalNetworkInterceptor);

// Response Interceptor
if (config.unifiedModules.pxEnabled) {
    interceptBuilder.interceptResponse(pxResponseInterceptor, { index: 0 }); // Enforce first interceptor
}

export const fetchApi = interceptBuilder.build();
